export default "__VITE_ASSET__BbgX3qE7__"